import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	position: relative;
	width: 100%;

	.menu-wrapper {
		position: absolute;
		width: 100%;
		top: -5em;
		z-index: 1000;
	}

	.expandable-menu {
		max-width: 1366px;
		margin: 0 auto;
		padding: 1.5em;
		background-color: #ffffff;
		border: 0.1em solid #000000;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		z-index: 98;

		.menu-header {
			display: flex;
			justify-content: space-between;
			align-items: center;

			.clear-control {
				.button {
					.button-content {
						font-weight: 300;
					}
				}
			}
		}

		.layout-forms-input {
			width: 30%;
			padding-top: 1em;

			.layout-forms-input-wrapper {
				.internal-wrapper {
					.input-decorator {
						color: #afaead;
						cursor: default;
						text-decoration: none;
					}
				}
			}
		}

		.menu-elements {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			padding: 2em 0;

			.element {
				cursor: pointer;
				padding-top: 0.5em;
			}
		}

		.link {
			align-self: flex-end;
			color: #000000;
		}
	}

	/* @media all and (max-width: ${vars.mobileL}) {
        .expandable-menu {
            .layout-forms-input {
                width: 100%;
            }
            .menu-elements {
                overflow: auto;
                grid-template-columns: repeat(4, 80%);
            }
        }
    } */

	@media all and (max-width: ${vars.tabletL}) {
		.menu-wrapper {
			top: 0;
		}
		.expandable-menu {
			z-index: 9;

			.layout-forms-input {
				width: 100%;
			}
			.menu-elements {
				display: flex;
				flex-flow: column wrap;

				.element {
					font-size: 1.4em;
					height: 2.2em;
					padding: 0.5em;
				}
			}
		}
	}
`;
